import { Order } from '@spa/store/modules/orderHistory/types'
import {
  AlreadyCanceledError,
  OrderHistoryNotFetchedError,
} from '../../modal-state'
import { SpecificationList, success, ValidationResult } from './index'

interface OrderSpecification {
  validate(input: Order | undefined | null): ValidationResult
}

export class OrderSpecificationList
  extends SpecificationList<Order, OrderSpecification>
  implements OrderSpecification {}

export class OrderMustExistSpecification implements OrderSpecification {
  constructor(private readonly postProcess: () => void) { }

  validate(input: Order | undefined | null): ValidationResult {
    const ifNonNull = requireNonNull(input, this.postProcess)

    return ifNonNull(success)
  }
}

const requireNonNull =
  (input: Order | undefined | null, postProcess: () => void) => (onExist: (_input: Order) => ValidationResult) => {
    if (!input) {
      return  {
        modalState: new OrderHistoryNotFetchedError(),
        postProcess,
        isInvalid: true,
      }
    }

    return onExist(input)
  }

export class CannotReorderForCanceledSpecification implements OrderSpecification {
  constructor(private readonly postProcess: () => void) { }

  validate(input: Order | undefined | null): ValidationResult {
    const ifNonNull = requireNonNull(input, this.postProcess)

    return ifNonNull((nonNullInput) => {
      if (nonNullInput.salesOrderStatus !== 'cancel') {
        return success()
      }

      return {
        modalState: new AlreadyCanceledError(),
        postProcess: this.postProcess,
        isInvalid: true,
      }
    })
  }
}
